import React, { useState } from "react";
import arrow from "../assets/arrow_petrol.svg";
import Nav from "../components/Nav";
import Circles from "../components/Circles";
import Button from "../components/Button";
import RankingList from "../components/RankingList";
import useFetch from "../hooks/useFetch";
import Tab from "../components/Tab";
import { Link } from "react-router-dom";

function Ranking() {
  const [showWeeklyRanking, setShowWeeklyRanking] = useState(false);
  const [showRanking, setShowRanking] = useState(true);
  const { weeklyRankingData, totalRankingData, loading, error } = useFetch();

  return (
    <section className="bg-petrol-500">
      <Nav />
      {loading && <p className="text-center">Laddar...</p>}
      {error && <p className="text-center">Något gick fel...</p>}
      {weeklyRankingData && (
        <div className="container">
          <h1 className="mb-2">Topplistan</h1>
          <div className="mb-10 flex justify-center gap-10">
            {/*<Tab
              state={showWeeklyRanking}
              title="Denna vecka"
              toggle={showWeekly}
            />*/}
            <Tab
              state={showRanking}
              title="Hela perioden"
              toggle={showTotalRanking}
            />
          </div>
          {totalRankingData && showRanking && (
            <RankingList data={totalRankingData} />
          )}
          {weeklyRankingData && showWeeklyRanking && (
            <RankingList data={weeklyRankingData} />
          )}
          <Link to="/quiz">
            <Button
              text="Börja spela"
              icon={arrow}
              buttonClass="primary mt-16"
            />
          </Link>
        </div>
      )}
      <Circles color="bg-syren-300" />
    </section>
  );

  function showWeekly() {
    setShowWeeklyRanking(true);
    setShowRanking(false);
  }

  function showTotalRanking() {
    setShowWeeklyRanking(false);
    setShowRanking(true);
  }
}

export default Ranking;
